<script>
/**
 * 右ペイン
 * ドライバースケジュール一覧
 */
import {mapActions}            from "vuex";
import OrderDetailModal        from "@/driver/pages/driver_schedules/modals/OrderDetailModal.vue";
import OrderInstructionModal   from "@/driver/pages/driver_schedules/modals/OrderInstructionModal.vue";
import AddOrderCollectionModal from "@/driver/pages/driver_schedules/modals/AddOrderCollectionModal.vue";
import AddOrderGeneralModal    from "@/driver/pages/driver_schedules/modals/AddOrderGeneralModal.vue";
import EditOrderModal from "@/driver/pages/driver_schedules/modals/EditOrderModal.vue";
import DriverSettingModal      from "@/driver/pages/driver_schedules/modals/DriverSettingModal.vue";
import AssociationOrderModal   from "@/driver/pages/driver_schedules/modals/AssociationOrderModal.vue";
import InstructionModal        from "@/driver/pages/driver_schedules/modals/InstructionModal.vue";
import Confirm from "../../../components/Confirm.vue";
import CompletionReportDialog from "../dialogs/_CompletionReportDialog.vue";
import QuickNotePreviewDialog from "@/driver/pages/driver_schedules/dialogs/_QuickNotePreviewDialog.vue";
import draggable from 'vuedraggable'
import utilMixins from '../../../mixins/utils';

export default {
  name: "DriverScheduleBlock",
  components: {
    AddOrderCollectionModal,
    AddOrderGeneralModal,
    CompletionReportDialog,
    Confirm,
    draggable,
    DriverSettingModal,
    AssociationOrderModal,
    OrderDetailModal,
    OrderInstructionModal,
    InstructionModal,
    QuickNotePreviewDialog,
    EditOrderModal,
  },
  mixins: [utilMixins],
  props: {
    /**
     * 開始日
     * @type {String}
     * @default null
     */
    startDate: {
      type: String,
      default: null,
    },
    /**
     * 日数
     * @type {Number}
     * @default null
     */
    numberOfDays: {
      type: Number,
      default: null
    },
    /**
     * 無効ドライバーID
     * @type {Array}
     * @default []
     */
    disableDriverIds: {
      type: Array,
      default: () => []
    },
    /**
     * ドライバー一覧
     * @type {Array}
     * @default []
     */
    drivers: {
      type: Array,
    },
  },

  data() {
    return {
      systemDate: this.$dayjs().format('YYYY-MM-DD'),
      /** 対象となる日付 */
      targetDate: null,
      /** 対象となるドライバーID */
      targetDriverId: null,
      /** 対象となるドライバー名 */
      targetDriverName: null,
      /** 選択された受注ID */
      choseOrderId: null,
      /** 選択された受注種別 */
      choseOrderType: null,
      /** 選択されたスケジュールID */
      choseScheduleId: null,
      /** 選択されたドライバースケジュールID */
      choseDriverScheduleId: null,
      /** 選択されたドライバースケジュール詳細ID */
      choseDriverScheduleDetailId: null,
      /** 受注（回収）登録 モーダル表示制御 */
      enableAddOrderCollectionModal: false,
      /** 受注（一廃）登録 モーダル表示制御 */
      enableAddOrderGeneralModal: false,
      enableCannotClearDriverTasksDialog: false,
      /** 受注詳細を参照 モーダル表示制御 */
      enableOrderDetailModal: false,
      /** 作業登録 モーダル表示制御 */
      enableAddInstructionModal: false,
      /** 受注編集 モーダル表示制御 */
      enableEditOrderModal: false,
      /** 受注紐付 モーダル表示制御 */
      enableAssociationOrderModal: false,
      /** 指示メモを編集 モーダル表示制御 */
      enableOrderInstructionModal: false,
      /** ドライバー設定 モーダル表示制御 */
      enableDriverSettingModal: false,
      /** 日毎のドライバー情報を管理 */
      targetOfDays: [],
      /** 変更前のprops */
      prevProps: {
        startDate: null,
        numberOfDays: null,
      },
      /* ↓運搬終了報告 */
      transportCompletionWaningMessages: null,
      enableTransportCompletionWaningDialog: false,
      completionTargetOrderIds: [],
      completionTargetManifestIds: [],
      enableCompletionModal: false,
      // ドラッグスクロール用の状態管理
      isDraggingScroll: false,
      dragStartX: 0,
      scrollStartX: 0,
      isLoading: true,
      // 簡易メモ表示用
      enableQuickNotePreview: false,
      // スクロール位置を保存
      scrollPosition: 0,
      // 初期化フラグ
      isInitialization: false,
    }
  },
  watch: {
    /**
     * propsの監視
     * メンバー個々に監視すると無駄な検索が増えるのでまとめて監視する.
     * newとoldでの判断が行えないため、変更された値を保持し、それを比較する
     */
    $props: {
      handler(newProps) {
        if (this.prevProps.startDate !== newProps.startDate ||
          this.prevProps.numberOfDays !== newProps.numberOfDays) {
          this.buildDayOfDriverSchedules();
        }
        this.prevProps = {
          startDate: newProps.startDate,
          numberOfDays: newProps.numberOfDays
        };
      },
      deep: true,
      immediate: true
    },
    /**
     * ドライバー情報の表示制御
     */
    disableDriverIds: function () {
      this.driverViewControl();
    }
  },
  computed: {
    /**
     * 日毎に展開されるドライバー情報
     * @returns {any}
     */
    totalDrivers() {
      return this.targetOfDays[0].members
    },
  },
  created() {
    this.buildDayOfDriverSchedules();
  },
  methods: {
    ...mapActions('DriverScheduleSchedule', {
      fetchSchedules: 'index',
      fetchSchedule: 'show',
      addSchedule: 'create',
      deleteSchedule: 'destroy',
    }),
    ...mapActions('DriverScheduleInstruction', {
      deleteInstruction: 'destroy'
    }),
    ...mapActions('DriverScheduleSortSetting', {
      updateSortSetting: 'update'
    }),
    ...mapActions('DriverScheduleScheduleSortPriority', {
      updateSortPriority: 'update',
    }),
    ...mapActions('DriverScheduleBulkDeletion', {
      bulkDeletion: 'destroy',
    }),
    ...mapActions("DriverOrderReportConfirmationVerification", {
      verification: "show",
    }),
    /**
     * ドライバーメニュー
     * 受注（回収）登録メニュー クリックイベント
     * @param evt
     * @param date
     * @param member
     */
    addCollectionButtonClickEvent(evt, date, member) {
      this.targetDate = date;
      this.targetDriverId = member.id;
      this.targetDriverName = member.name;
      this.enableAddOrderCollectionModal = true;
    },
    /**
     * ドライバーメニュー
     * 受注（一廃）登録メニュー クリックイベント
     * @param date
     * @param member
     */
    addGeneralButtonClickEvent (date, member) {
      this.targetDate = date;
      this.targetDriverId = member.id;
      this.targetDriverName = member.name;
      this.enableAddOrderGeneralModal = true;
    },
    /**
     * ドライバーメニュー
     * 作業登録メニュー クリックイベント
     * @param date
     * @param driverId
     */
    addInstructionButtonClickEvent (date, driverId) {
      this.targetDate = date;
      this.targetDriverId = driverId;
      this.enableAddInstructionModal = true;
    },
    /**
     * ドライバースケジュールメニュー
     * 詳細を参照メニュー クリックイベント
     * @param schedule
     */
    showDetailMenuClickEvent (schedule) {
      this.choseOrderId = schedule.order_id;
      this.choseOrderType = schedule.order_type
      this.enableOrderDetailModal = true;
    },
    /**
     * ドライバースケジュールメニュー
     * 受注紐付メニュー クリックイベント
     */
    associationOrderButtonClickEvent(date, member) {
      this.targetDate = date;
      this.targetDriverId = member.id;
      this.targetDriverName = member.name;
      this.enableAssociationOrderModal = true;
    },
    /**
     * ドライバースケジュールメニュー
     * 運搬終了報告兼本登録メニュー クリックイベント
     * @param date { String } 対象日
     * @param member { Object } 対象日のドライバー・スケジュール情報
     */
    transportCompletionReportButtonClickEvent(date, member) {
      this.completionTargetOrderIds = [];
      for (const schedule of member.schedules) {
        if (schedule.schedule_type === 'collection') {
          this.completionTargetOrderIds.push(schedule.order_id);
        }
      }
      const params = {
        ids: this.completionTargetOrderIds.join(","),
        report_type: 'completion',
        display_type: 'Accepts',
        mixed_order: true
      };
      this.transportCompletionWaningMessages = null;
      this.verification({ params: params }).then((content) => {
        if (content.status === "success") {
          this.completionTargetManifestIds = content.manifest_ids;
          this.enableCompletionModal = true;
          this.choseDriverScheduleId = member.driver_schedule_id
        } else {
          this.transportCompletionWaningMessages = content.error_message;
          this.enableTransportCompletionWaningDialog = true;
        }
      });
    },
    /**
     * ドライバースケジュールメニュー
     * 受注の紐付けをすべて解除メニュー クリックイベント
     * @param date
     * @param member
     */
    bulkDeletionButtonClickEvent(date, member) {
      let result = member.schedules.find((schedule) => { return (schedule.schedule_type === 'collection' && schedule.confirmed) })
      if (result) {
        this.enableCannotClearDriverTasksDialog = true
      } else {
        let modalOption = { title: '受注の紐付けを解除', message: 'すべての受注の紐付けを解除します。よろしいですか？', options: { titleColor: 'red', width: 350, cancelTitle: 'いいえ', successTitle: 'はい' } }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.bulkDeletion({ driver_schedule_id: member.driver_schedule_id }).then(() => {
              this.loadDriverSchedules(date, member.id)
              this.$emit("callSearchBlock");
            })
          }
        })
      }
    },
    /**
     * ドライバースケジュール詳細メニュー
     * 受注編集メニュー クリックイベント
     * @param schedule
     */
    editOrderMenuClickEvent (schedule) {
      this.choseOrderId = schedule.order_id;
      this.choseOrderType = schedule.order_type
      this.enableEditOrderModal = true;

    },
    /**
     * ドライバースケジュール詳細メニュー
     * 指示メモを編集メニュー クリックイベント
     * @param evt { Event } イベント
     * @param date { Date } 日付
     * @param member { Object } ドライバー
     * @param schedule { Object } 受注ID
     */
    orderInstructionMenuClickEvent(evt, date, member, schedule) {
      this.choseOrderId = schedule.order_id;
      this.targetDate = date;
      this.targetDriverId = member.id;
      this.enableOrderInstructionModal = true;
    },
    /**
     * ドライバースケジュール詳細メニュー
     * ドライバー設定メニュー クリックイベント
     * @param evt
     * @param schedule
     */
    driverSettingMenuClickEvent(evt, schedule) {
      this.choseOrderId = schedule.order_id;
      this.choseDriverScheduleId = schedule.driver_schedule_id
      this.choseDriverScheduleDetailId = schedule.id
      this.enableDriverSettingModal = true;
    },
    /**
     * ドライバースケジュール詳細メニュー
     * 受注の紐付けを解除メニュー クリックイベント
     * @param date { Date } 日付
     * @param member { Object } ドライバー
     * @param driver_schedule_detail { Object } ドライバースケジュール詳細
     */
    detachDriverScheduleMenuClickEvent(date, member, driver_schedule_detail) {
      let modalOption = {
        title: "確認",
        message: driver_schedule_detail.can_edit_transport_user ? "紐付けを解除します。よろしいですか？" : "運搬終了報告の登録が完了されているので紐付け解除出来ません",
        options: { width: 450, titleColor: "red", isCancelButton: true },
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm && driver_schedule_detail.can_edit_transport_user) {
          this.deleteSchedule({ driver_schedule_id: driver_schedule_detail.driver_schedule_id, driver_schedule_detail_id: driver_schedule_detail.id }).then(() => {
            this.loadDriverSchedules(date, member.id);
            this.$emit("callSearchBlock");
          });
        }
      })
    },
    /**
     * ドライバースケジュール詳細メニュー
     * 作業を編集メニュー クリックイベント
     * @param scheduleId
     * @param driverId
     */
    editInstructionMenuClickEvent(scheduleId, driverId) {
      this.choseScheduleId = scheduleId
      this.targetDriverId = driverId
      this.enableAddInstructionModal = true
    },
    /**
     * ドライバースケジュール詳細メニュー
     * 作業を削除メニュー クリックイベント
     *
     * @param scheduleId { Number } ドライバースケジュールID
     * @param driverId
     */
    removeInstructionMenuClickEvent(scheduleId, driverId) {
      const modalOption = {
        title: '削除確認',
        message: '削除します。よろしいですか？',
        options: {
          titleColor: 'red',
          cancelTitle: 'いいえ',
          successTitle: 'はい'
        }
      }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close();
        if (confirm) {
          this.deleteInstruction({ driver_id: driverId, id: scheduleId }).then(() => {
            this.loadDayOfDriverSchedules();
          });
        }
      });
    },
    /**
     * スクロール位置を保存
     */
    saveScrollPosition() {
      if (this.$refs.scrollContainer) {
        this.scrollPosition = this.$refs.scrollContainer.scrollLeft;
      }
    },
    /**
     * スクロール位置を復元
     */
    restoreScrollPosition() {
      if (this.$refs.scrollContainer && this.scrollPosition >= 0) {
        this.$nextTick(() => {
          // 少し遅延を加えてDOM更新を確実に待つ
          setTimeout(() => {
            this.$refs.scrollContainer.scrollLeft = this.scrollPosition;
          }, 50);
        });
      }
    },
    scheduleDragStartEvent () {
      window.document.body.style.cursor = 'grabbing';
    },
    /**
     * リスト内並び替えイベント
     * @param evt
     * @param member { Object }
     */
    scheduleDragEndEvent (evt, member) {
      const from_index = evt.oldIndex;
      const to_index = evt.newIndex;
      if (from_index !== to_index) {
        // ブロック内のドライバースケジュール詳細IDを抽出
        const sorted_schedules = member.schedules.map((schedule) => {
          return {
            id: schedule.driver_schedule_detail_id,
          }
        });
        const params = {
          sorted_schedules: sorted_schedules,
        }
        this.updateSortPriority({ driver_schedule_id: member.driver_schedule_id, params: params }).then((content) => {
          member.schedules = content.schedules
          member.instruction_schedules = content.instruction_schedules
        });
      }
      window.document.body.style.cursor = 'default';
    },
    /**
     * ドライバースケジュール詳細 追加イベント
     * リストに追加されたカードを登録する
     * @param evt { Event }
     * @param date { String }
     * @param member { Object }
     */
    scheduleAddEvent (evt, date, member) {

      const schedule = member.schedules.find((schedule) => schedule.scheduled === false);
      if (!schedule) {
        return false;
      }
      // ブロック内のドライバースケジュール詳細IDを抽出
      // 左ペインからドロップされたカードはドライバースケジュール詳細IDがundefinedなのでnullに置き換え
      const sorted_schedules = member.schedules.map((schedule) => {
        return {
          id: schedule.driver_schedule_detail_id ? schedule.driver_schedule_detail_id : null,
        }
      });
      // 登録完了のレスポンス結果を再設定し、登録された情報を描画
      this.addSchedule({ target_date: date, driver_id: member.id, order_id: schedule.order_id, sorted_schedules: sorted_schedules }).then((content) => {
        if (!member.driver_schedule_id) {
          member.driver_schedule_id = content.driver_schedule_id
        }
        member.schedules = content.schedules
        member.instruction_schedules = content.instruction_schedules
      })
    },
    /**
     * モーダル クローズ コールバック
     * 一時的に設定した値を初期化する共通処理
     */
    closeModalCallback() {
      this.targetDate = null;
      this.choseOrderId = null;
      this.choseOrderType = null;
      this.choseScheduleId = null;

      this.choseDriverScheduleId = null;
      this.choseDriverScheduleDetailId = null;

      this.targetDriverId = null;
      this.targetDriverName = null;

      this.transportCompletionWaningMessages = [];
      this.completionTargetOrderIds = [];
      this.completionTargetManifestIds = [];

      this.enableCannotClearDriverTasksDialog = false;

      this.enableOrderInstructionModal = false
      this.enableOrderDetailModal = false
      this.enableAddOrderCollectionModal = false;
      this.enableAddOrderGeneralModal = false;
      this.enableEditOrderModal = false;
      this.enableDriverSettingModal = false;
      this.enableAssociationOrderModal = false;
      this.enableAddInstructionModal = false;
      this.enableTransportCompletionWaningDialog = false;
      this.enableCompletionModal = false;
      this.enableQuickNotePreview = false;
    },
    /**
     * 運搬終了報告兼本登録モーダル
     * 登録後のコールバック
     */
    completionReportRegisterCallback() {
      this.loadDayOfDriverSchedules();
      this.closeModalCallback();
    },
    /**
     * 受注登録モーダル
     * 登録後のコールバック
     */
    addOrderCollectionModalRegisterCallback () {
      this.loadDayOfDriverSchedules();
      this.closeModalCallback();
    },
    /**
     * 詳細を参照モーダル
     * ドライバースケジュールのリフレッシュ
     */
    orderDetailRefreshCallback () {
      this.reloadDaysOfSchedules();
      this.$emit("callSearchBlock");
    },
    /**
     * 詳細を参照モーダル
     * ドライバースケジュールのリフレッシュ
     */
    orderDetailCloseCallback () {
      // this.loadDayOfDriverSchedules();
      // this.$emit("callSearchBlock");
      this.closeModalCallback();
    },
    /**
     * ドライバー設定
     * 登録後のコールバック
     */
    driverSettingModalRegisterCallback() {
      this.loadDayOfDriverSchedules();
      this.$emit("callSearchBlock");
      this.closeModalCallback();
    },
    /**
     * ドライバー指示メモを編集
     * 登録後のコールバック
     */
    orderInstructionModalRegisterCallback () {
      this.loadDriverSchedules(this.targetDate, this.targetDriverId);
      this.closeModalCallback();
    },
    /**
     * 受注紐付けモーダル
     * 登録後のコールバック
     */
    associationOrderModalRegisterCallback () {
      this.$emit("callSearchBlock");
      this.loadDayOfDriverSchedules();
      this.closeModalCallback();
    },
    /**
     * 作業登録モーダル
     * 登録後のコールバック
     */
    instructionModalRegisterCallback() {
      this.loadDayOfDriverSchedules();
      this.closeModalCallback();
    },
    /**
     * ドライバーの表示設定
     * 左ペインのドライバーの表示制御と連動させる
     */
    driverViewControl () {
      this.targetOfDays.forEach(day => {
        day.members.forEach(member => {
          member.showable = !this.disableDriverIds.includes(member.id);
        })
      })
    },
    /**
     * 日を表すボタンの展開
     */
    buildDayOfDriverSchedules () {
      this.isInitialization = true; // 初期化フラグを設定
      this.dayButtonClickEvent(0);
      this.targetOfDays = []
      for (let i = 0; i < this.numberOfDays; i++) {
        this.targetOfDays.push({
          date: this.$dayjs(this.startDate).add(i, 'days').format('YYYY-MM-DD'),
          key: this.$dayjs(this.startDate).add(i, 'days').format('YYYYMMDD'),
          selected: (this.startDate === this.$dayjs(this.startDate).add(i, 'days').format('YYYY-MM-DD')),
          week: this.$dayjs(this.startDate).add(i, 'days').format('ddd'),
          members: [],
        })
      }
      this.loadDayOfDriverSchedules();
    },
    /**
     * 日毎のドライバースケジュールの展開
     */
    loadDayOfDriverSchedules () {
      // 初期化時以外はスクロール位置を保存
      if (!this.isInitialization) {
        this.saveScrollPosition(); // スクロール位置を保存
      }
      this.isLoading = true;
      this.targetOfDays.forEach((day, index) => {
        this.fetchSchedules({ target_date: day.date }).then((response) => {
          day.members = response.driver_schedules;
          if (this.targetOfDays.length === index + 1) {
            setTimeout(() => {
              this.isLoading = false;
              // 初期化時以外はスクロール位置を復元
              if (!this.isInitialization) {
                this.$nextTick(() => {
                  this.restoreScrollPosition(); // スクロール位置を復元
                });
              } else {
                this.isInitialization = false; // 初期化フラグをリセット
              }
            }, 600)
          }
        }).finally(() =>{
          this.driverViewControl();
        });
      })

    },
    /**
     * ドライバースケジュール再読込
     */
    reloadDaysOfSchedules () {
      this.targetOfDays.forEach((day, index) => {
        this.fetchSchedules({ target_date: day.date }).then((response) => {
          day.members = response.driver_schedules;
        }).finally(() =>{
          this.driverViewControl();
        });
      })
    },
    /**
     * 対象日・対象ユーザーのスケジュールを取得
     * @param date
     * @param driver_id
     */
    loadDriverSchedules (date, driver_id) {
      this.saveScrollPosition(); // スクロール位置を保存
      const member = this.targetOfDays.find((day) => day.date === date).members.find((member) => member.id === driver_id)
      // 対象のドライバーのスケジュールを再取得
      if (member) {
        this.fetchSchedule({ target_date: date, driver_id: driver_id }).then((content) => {
          member.schedules = content.schedules
          this.$nextTick(() => {
            this.restoreScrollPosition(); // スクロール位置を復元
          });
        });
      }
    },
    /**
     * 日付ボタン クリックイベント
     * 選択したボタンの背景色の変更と指定一までスクロール
     * @param i { Number } インデックス
     */
    dayButtonClickEvent (i) {
      if (this.targetOfDays.length === 0) {
        return false;
      }
      this.$refs.dayArea[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
      this.targetOfDays.forEach((day) => {
        day.selected = false
      })
      this.targetOfDays[i].selected = true
    },
    /**
     * スケジュールに表示するアイコンを設定
     * @param orderStatus
     * @returns {string}
     */
    scheduleStatusIcon(orderStatus) {
      switch (orderStatus) {
        // 受注
        case "order_received":
          return "mdi-circle-outline";
        // 回収済
        case "retrieved":
          return "mdi-circle-half-full";
        // 運搬済
        case "transported":
          return "mdi-circle";
        // 運搬終了報告済
        case "transport_reported":
          return "mdi-circle";
        default:
          return "";
      }
    },
    /**
     * スケジュールに表示するアイコンの色を設定
     * @param hasChangedByDriver
     * @param orderStatus
     * @returns {string}
     */
    scheduleStatusColor(hasChangedByDriver, orderStatus = "") {
      if (hasChangedByDriver) {
        return "warning";
      } else if (orderStatus === "transport_reported") {
        return "gray";
      } else {
        return "primary";
      }
    },
    scheduleStatusOutlineIcon(orderStatus) {
      // if (orderStatus !==  'transport_reported') {
      return "mdi-circle-outline";
      // }
    },
    /**
     * マウスダウンイベントのハンドラー
     * @param e
     */
    handleMouseDown(e) {
      // 右クリックのみを処理
      if (e.button === 2) {
        this.startScrollDrag(e);
      }
    },
    /**
     * ドラッグスクロール開始
     * @param e
     */
    startScrollDrag(e) {
      e.preventDefault();
      this.isDraggingScroll = true;
      this.dragStartX = e.pageX;
      this.scrollStartX = this.$refs.scrollContainer.scrollLeft;

      // カーソルを掴む手のアイコンに変更
      document.body.style.cursor = 'grabbing';

      // スクロールを滑らかにするのを無効化
      this.$refs.scrollContainer.style.scrollBehavior = 'auto';

      // ドラッグ中はテキスト選択を無効化
      document.body.style.userSelect = 'none';

      // イベントリスナーを追加
      document.addEventListener('mousemove', this.handleScrollDrag);
      document.addEventListener('mouseup', this.stopScrollDrag);
    },
    /**
     * ドラッグ中の処理
     * @param e
     */
    handleScrollDrag(e) {
      if (!this.isDraggingScroll) return;

      e.preventDefault();

      // マウスの移動量を計算
      const deltaX = e.pageX - this.dragStartX;

      // スクロール位置を更新（移動量に応じてスクロール速度を調整）
      this.$refs.scrollContainer.scrollLeft = this.scrollStartX - (deltaX * 1.5);
    },
    /**
     * ドラッグ終了時の処理
     */
    stopScrollDrag() {
      if (!this.isDraggingScroll) return;

      this.isDraggingScroll = false;

      // カーソルをデフォルトに戻す
      document.body.style.cursor = '';

      // スクロールを滑らかにするのを有効化
      this.$refs.scrollContainer.style.scrollBehavior = 'smooth';

      // テキスト選択を有効化
      document.body.style.userSelect = '';

      // イベントリスナーを削除
      document.removeEventListener('mousemove', this.handleScrollDrag);
      document.removeEventListener('mouseup', this.stopScrollDrag);
    },
    /**
     * 簡易メモプレビューの表示
     * @param schedule
     */
    showQuickNotePreview(schedule) {
      this.choseOrderId = schedule.order_id;
      this.enableQuickNotePreview = true;
    },
    /**
     * メモまたは写真が存在するかチェック
     * @param schedule
     * @returns {boolean}
     */
    hasNotesOrPhotos(schedule) {
      return (schedule.local_notes && schedule.local_notes.trim()) || (schedule.photo_count && schedule.photo_count > 0);
    },
    /**
     * 簡易メモプレビューエラーハンドリング
     * @param {String} errorMessage エラーメッセージ
     */
    handleQuickNoteError(errorMessage) {
      // エラー処理（必要に応じてスナックバーなどで表示）
      console.error('簡易メモプレビューエラー:', errorMessage);
    },
  },
}

</script>

<template>
  <div
    class="resizable-schedule-container"
    ref="scrollContainer"
  >
    <div class="schedule-base-layout-container">
      <v-overlay :value="isLoading">
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <div v-if="!isLoading" style="height: 100%;">
        <section
          v-if="targetOfDays"
          style="position: relative;height: 100%;"
        >
          <template
            v-if="totalDrivers.length > 0 && totalDrivers.length === disableDriverIds.length"
          >
            <div>
              <v-alert
                color="red lighten-1"
                dark
                class="text-center"
              >
                表示可能なドライバー情報がありません。
              </v-alert>
            </div>
          </template>
          <div
            v-else
            class="d-flex daily-swipeable-container"
            @mousedown="handleMouseDown"
            @contextmenu.prevent
          >
            <div
              v-for="(day, i) in targetOfDays"
              :key="i"
              style="height: 100%;"
            >
              <div
                ref="dayArea"
                class="d-inline-block mr-4"
                style="height: 100%;display: contents;flex-direction: column;"
              >
                <!-- 日付ボタン -->
                <v-btn
                  :color="day.selected ? 'info' : ''"
                  block
                  class="mb-2"
                  style="width: 100%;"
                  @click="dayButtonClickEvent(i)"
                >
                  {{ day.date | date_format }}（{{ day.week }}）
                </v-btn>
                <!-- /日付ボタン -->
                <div
                  class="d-flex"
                  style="width: 100%;height: calc(100% - 45px)"
                >
                  <template
                    v-for="(member, index) in day.members"
                  >
                    <div
                      v-if="member.showable"
                      :key="member.id"
                      :style="{ marginRight: index === day.members.length - 1 ? '0' : '8px' }"
                    >
                      <v-card
                        flat
                        style="width: 14rem;height: 100%;"
                        outlined
                        class="driver-block"
                      >
                        <!-- ドライバー名 -->
                        <v-toolbar flat dense style="height: 40px;">
                          <v-toolbar-title style="height: 40px;">
                            <v-menu
                              bottom
                              left
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                                  small
                                  color="primary"
                                >
                                  <v-icon>mdi-plus-circle</v-icon>
                                </v-btn>
                              </template>

                              <v-list dense>
                                <v-list-item @click="addCollectionButtonClickEvent($event, day.date, member)">
                                  <v-list-item-title>受注登録（産廃）</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="addGeneralButtonClickEvent(day.date, member)">
                                  <v-list-item-title>受注登録（一廃）</v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="addInstructionButtonClickEvent(day.date, member.id)">
                                  <v-list-item-title>作業登録</v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                            &nbsp;
                            <span class="text-center body-2" :title="member.name">{{ member.name }}</span>
                          </v-toolbar-title>
                          <v-spacer />
                          <v-menu
                            bottom
                            left
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                icon
                                small
                              >
                                <v-icon small>mdi-dots-horizontal</v-icon>
                              </v-btn>
                            </template>

                            <v-list dense>
                              <v-list-item
                                @click="associationOrderButtonClickEvent(day.date, member)"
                              >
                                <v-list-item-title>受注紐付け</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="transportCompletionReportButtonClickEvent(day.date, member)"
                              >
                                <v-list-item-title>運搬終了報告兼本登録</v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                :disabled="!member.driver_schedule_id"
                                @click="bulkDeletionButtonClickEvent(day.date, member)"
                              >
                                <v-list-item-title class="red--text">受注の紐付けをすべて解除</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-toolbar>
                        <!-- /ドライバー名 -->
                        <v-divider />
                        <!-- ドライバースケジュール一覧 -->
                        <v-card-text
                          class="py-1 pb-5 driver-schedule-detail-block"
                        >
                          <draggable
                            v-model="member.schedules"
                            :group="{ name: 'schedules', pull: false, put: true, targetDate: day.date }"
                            :sort="true"
                            :animation="300"
                            :scroll-sensitivity="40"
                            filter=".ignore"
                            ghost-class="schedule-card-ghost"
                            item-key="id"
                            @start="scheduleDragStartEvent"
                            @add="scheduleAddEvent($event, day.date, member)"
                            @end="scheduleDragEndEvent($event, member)"
                          >
                            <transition-group
                              type="transition"
                              name="flip-list"
                              tag="div"
                              style="min-height: 40vh;"
                            >
                              <div
                                v-for="(schedule) in member.schedules"
                                :key="schedule.id"
                                style="width: 100%;"
                              >
                                <!-- 受注登録カード -->
                                <v-card
                                  v-if="schedule.schedule_type === 'collection'"
                                  :elevation="1"
                                  :flat="false"
                                  :style="(!schedule.reserved && schedule.driver_schedule_status !== 'transport_reported' && ['collection', 'general'].includes(schedule.order_type)) ? 'border: 1px dashed #bdbdbd !important;' : ''"
                                  class="mb-1"
                                  rounded
                                >
                                  <v-toolbar
                                    class="px-0 schedule-title black--text"
                                    dense
                                    flat
                                    height="24"
                                  >
                                    <v-toolbar-title class="pb-2" style="width: 100%;">
                                      <span class="icon-container">
                                        <v-icon
                                          :color="schedule.driver_schedule_status === 'transport_reported' ? 'gray' : 'primary'"
                                          small
                                          class="icon-overlay"
                                        >
                                          {{ scheduleStatusIcon(schedule.driver_schedule_status) }}
                                        </v-icon>
                                        <v-icon
                                          small
                                          :color="scheduleStatusColor(schedule.edited, schedule.driver_schedule_status)"
                                          class="icon-background"
                                        >
                                          {{ scheduleStatusOutlineIcon(schedule.driver_schedule_status) }}
                                        </v-icon>
                                      </span>&nbsp;<span style="font-size: 0.7rem;">{{ schedule.order_type_label }}: {{ dsOrderRequestNumber(schedule) }}</span>
                                    </v-toolbar-title>
                                    <v-spacer />
                                    <!-- 現地メモプレビューアイコン -->
                                    <v-btn
                                      v-if="hasNotesOrPhotos(schedule)"
                                      color="info"
                                      icon
                                      small
                                      @click="showQuickNotePreview(schedule)"
                                    >
                                      <v-icon small>mdi-note-text</v-icon>
                                    </v-btn>
                                    <v-menu
                                      bottom
                                      left
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          icon
                                          small
                                        >
                                          <v-icon small>mdi-dots-horizontal</v-icon>
                                        </v-btn>
                                      </template>
                                      <v-list dense>

                                        <!-- 0: collection_requested: 産廃回収（未受付） -->
                                        <!-- 1: collection_accepted: 産廃回収（受注） -->
                                        <!-- 4: collection_transported: 産廃回収（運搬完了） -->
                                        <v-list-item
                                          v-if="['collection_requested', 'collection_accepted', 'collection_transported'].includes(schedule.status)"
                                          @click="editOrderMenuClickEvent(schedule)"
                                        >
                                          <v-list-item-title>受注編集</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                          v-else
                                          @click="showDetailMenuClickEvent(schedule)"
                                        >
                                          <v-list-item-title>詳細を参照</v-list-item-title>
                                        </v-list-item>

                                        <v-list-item
                                          @click="orderInstructionMenuClickEvent($event, day.date, member, schedule)"
                                        >
                                          <v-list-item-title>指示メモを編集</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                          @click="driverSettingMenuClickEvent($event, schedule)"
                                        >
                                          <v-list-item-title>運搬設定を変更</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                          @click="detachDriverScheduleMenuClickEvent(day.date, member, schedule)"
                                        >
                                          <v-list-item-title class="red--text">受注の紐付けを解除</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </v-toolbar>
                                  <v-divider light />
                                  <v-card-text
                                    class="pb-0 pt-1"
                                    style="padding-left: 8px; padding-right: 8px;"
                                  >
                                    <div
                                      :title="`受注番号: ${ schedule.order_no}\n引取搬入番号: ${ schedule.request_no || ''}\n${schedule.emission_name || ''}\n${schedule.emission_location_name || ''}\n${schedule.emission_location_address || ''}\n${schedule.item_name || ''}`"
                                      class="text-ellipsis"
                                      style="line-height: 15px;"
                                    >
                                      <span class="black--text" style="font-size: 0.65rem;">{{ schedule.emission_name }}</span>
                                    </div>
                                    <div
                                      :title="`受注番号: ${ schedule.order_no}\n引取搬入番号: ${ schedule.request_no || ''}\n${schedule.emission_name || ''}\n${schedule.emission_location_name || ''}\n${schedule.emission_location_address || ''}\n${schedule.item_name || ''}`"
                                      class="text-ellipsis"
                                      style="line-height: 15px;"
                                    >
                                      <span class="black--text" style="font-size: 0.65rem;">{{ schedule.emission_location_name }}</span>
                                    </div>
                                    <div
                                      :style="`padding-bottom: ${ (schedule.plan_start_time || schedule.plan_end_time) ? 0 : '4px' };`"
                                      :title="`${schedule.dispose_name || ''}\n${schedule.dispose_location_name || ''}\n${schedule.dispose_location_address || ''}`"
                                      class="primary--text"
                                      style="line-height: 15px;"
                                    >
                                      <span
                                        class="line-clamp one-clamp float-left"
                                        style="font-size: 0.65rem;width: 75%">{{ schedule.dispose_location_name }}
                                      </span>
                                      <span class="text-right float-left" style="padding-bottom: 2px;display: inline-block;font-size: 0.65rem;width: 25%"> 全{{schedule.destination_count}}件 </span>
                                    </div>
                                    <div
                                      class="text-right float-right"
                                      style="line-height: 15px;"
                                    >
                                    <span class="black--text" style="font-size: 0.6rem" v-if="schedule.plan_start_time || schedule.plan_end_time">
                                      （{{ schedule.plan_start_time }}〜{{ schedule.plan_end_time }}）
                                    </span>
                                    </div>
                                    <br class="clearfix" />
                                  </v-card-text>
                                </v-card>
                                <!-- /受注登録カード -->

                                <!-- 作業登録カード -->
                                <v-card
                                  v-else
                                  :elevation="1"
                                  :flat="false"
                                  class="mb-1 orange lighten-4"
                                  rounded
                                  height="90"
                                >
                                  <v-toolbar
                                    class="orange lighten-4 schedule-title"
                                    dense
                                    flat
                                    height="28"
                                  >
                                    <v-toolbar-title>
                              <span
                                :title="`${schedule.title || ''}`"
                                class="line-clamp black--text"
                                style="font-size: 0.7rem;width: 100%"
                              >
                                {{ schedule.title }}
                              </span>
                                    </v-toolbar-title>
                                    <v-spacer />
                                    <v-menu
                                      bottom
                                      left
                                    >
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          v-bind="attrs"
                                          v-on="on"
                                          icon
                                          small
                                        >
                                          <v-icon small>mdi-dots-horizontal</v-icon>
                                        </v-btn>
                                      </template>

                                      <v-list dense>
                                        <v-list-item
                                          @click="editInstructionMenuClickEvent(schedule.id, member.id)"
                                        >
                                          <v-list-item-title>作業を編集</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                          @click="removeInstructionMenuClickEvent(schedule.id, member.id)"
                                        >
                                          <v-list-item-title class="red--text">作業を削除</v-list-item-title>
                                        </v-list-item>
                                      </v-list>
                                    </v-menu>
                                  </v-toolbar>
                                  <v-divider />
                                  <v-card-text class="py-1" style="padding-left: 8px; padding-right: 8px;">
                                    <div
                                      :title="`${schedule.content || ''}`"
                                      class="line-clamp three-clamp black--text"
                                      style="white-space: pre-line;font-size: 0.6rem;line-height: 12px"
                                    >
                                      {{ schedule.content }}
                                    </div>
                                  </v-card-text>
                                </v-card>
                                <!-- /作業登録カード -->

                              </div>
                            </transition-group>
                          </draggable>
                        </v-card-text>
                        <!-- /ドライバースケジュール一覧 -->
                      </v-card>
                    </div>
                  </template>

                </div>

              </div>
            </div>
          </div>

          <confirm ref="confirm" />

          <!-- 受注編集 -->
          <edit-order-modal
            :enable-dialog="enableEditOrderModal"
            :order-id="choseOrderId"
            :order-type="choseOrderType"
            @closeCallback="closeModalCallback"
            @registerCallback="completionReportRegisterCallback"
          />
          <!-- /受注編集 -->

          <!-- 受注登録 -->
          <add-order-collection-modal
            :enable-dialog="enableAddOrderCollectionModal"
            :target-date="targetDate"
            :transport-user-id="targetDriverId"
            :transport-user-name="targetDriverName"
            @closeCallback="closeModalCallback"
            @registerCallback="addOrderCollectionModalRegisterCallback"
          />
          <!-- /受注登録 -->

          <add-order-general-modal
            :enable-dialog="enableAddOrderGeneralModal"
            :target-date="targetDate"
            :transport-user-id="targetDriverId"
            :transport-user-name="targetDriverName"
            @closeCallback="closeModalCallback"
            @registerCallback="addOrderCollectionModalRegisterCallback"
          />

          <!-- 運搬終了報告(個別) -->
          <completion-report-dialog
            :driver-schedule-id="choseDriverScheduleId"
            :enable-dialog="enableCompletionModal"
            :manifest-ids="completionTargetManifestIds"
            :order-ids="completionTargetOrderIds"
            sort-type="updated_date_desc"
            type="Accepts"
            @cancelCallback="closeModalCallback"
            @registerEvent="completionReportRegisterCallback"
          />

          <!-- 詳細を参照 -->
          <order-detail-modal
            :enable-dialog="enableOrderDetailModal"
            :order-id="choseOrderId"
            :order-type="choseOrderType"
            @closeCallback="orderDetailCloseCallback"
            @modalRefreshCallback="orderDetailRefreshCallback"
          />
          <!-- /詳細を参照 -->

          <!-- ドライバー指示メモを編集 -->
          <order-instruction-modal
            :enable-dialog="enableOrderInstructionModal"
            :order-id="choseOrderId"
            @closeCallback="closeModalCallback"
            @registerCallback="orderInstructionModalRegisterCallback"
          />
          <!-- /ドライバー指示メモを編集 -->

          <!-- ドライバー設定 -->
          <driver-setting-modal
            :enable-dialog="enableDriverSettingModal"
            :order-id="choseOrderId"
            :driver-schedule-id="choseDriverScheduleId"
            :driver-schedule-detail-id="choseDriverScheduleDetailId"
            :drivers="drivers"
            @closeCallback="closeModalCallback"
            @registerCallback="driverSettingModalRegisterCallback"
          />
          <!-- /ドライバー設定 -->

          <!-- 受注紐付け -->
          <association-order-modal
            :enable-dialog="enableAssociationOrderModal"
            :target-date="targetDate"
            :target-driver-id="targetDriverId"
            :target-driver-name="targetDriverName"
            :order-id="choseOrderId"
            :drivers="drivers"
            @closeCallback="closeModalCallback"
            @registerCallback="associationOrderModalRegisterCallback"
          />
          <!-- /受注紐付け -->

          <!-- 作業登録 -->
          <instruction-modal
            :enable-dialog="enableAddInstructionModal"
            :chose-schedule-id="choseScheduleId"
            :target-date="targetDate"
            :target-driver-id="targetDriverId"
            @closeCallback="closeModalCallback"
            @registerCallback="instructionModalRegisterCallback"
          />
          <!-- /作業登録 -->

          <v-dialog
            v-model="enableTransportCompletionWaningDialog"
            persistent
            width="500"
          >
            <v-card>
              <v-card-title class="text-h5 red darken-2 white--text">
                確認
              </v-card-title>
              <v-divider />
              <v-card-text>
                <h4 class="mt-4">
                  {{ transportCompletionWaningMessages }}
                </h4>
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn @click="enableTransportCompletionWaningDialog = false"> 閉じる </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="enableCannotClearDriverTasksDialog"
            width="500"
            @click:outside="closeModalCallback"
            @keydown.esc="closeModalCallback"
            @close="closeModalCallback"
          >
            <v-card>
              <v-toolbar
                color="red"
                dark
                dense
                flat
              >
                <v-toolbar-title class="white--text">
                  警告
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text class="pa-4 text-center">
                解除が行えない受注が含まれているため一括解除できません。<br />
                解除する場合は、個別に解除を行ってください。
              </v-card-text>
              <v-divider />
              <v-card-actions>
                <v-spacer />
                <v-btn
                  @click="closeModalCallback"
                >
                  閉じる
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- 現地情報プレビュー -->
          <quick-note-preview-dialog
            :enable-dialog="enableQuickNotePreview"
            :order-id="choseOrderId"
            @closeCallback="closeModalCallback"
            @error="handleQuickNoteError"
          />

        </section>
      </div>
    </div>
  </div>

</template>

<style scoped lang="scss">

.resizable-schedule-container {
  height: 100%;
  //min-height: calc(100vh - 380px);
  max-height: calc(100vh - 210px);
  display: flex;
  position: relative;
  overflow-x: scroll;
  overflow-y: hidden;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  transform: rotateX(180deg);

  & .schedule-base-layout-container {
    transform: rotateX(180deg);
    height: 100%;

    & .daily-swipeable-container {
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      scroll-behavior: smooth;
      min-height: 0;
      height: 100%;
      & .driver-schedule-detail-block {
        height: calc(100vh - 315px);
        overflow-y: auto;
        overflow-x: hidden;
        padding-left: 8px;
        padding-right: 8px;
        user-select: none;
      }
    }


  }
}



</style>
<style lang="scss">

.resizable-schedule-container {

  .driver-block {
    & .v-toolbar__content {
      padding-left: 10px !important;
    }
  }

}


.icon-container {
  position: relative;
  display: inline-block; /* 必要に応じて */
  width: 18px;
  height: 18px;
  & i:first-child {
    position: absolute;
    top: 25%;
    left: 0;
    font-size: 18px !important;
  }
  & i:last-child {
    position: absolute;
    top: 25%;
    left: 0;
    font-size: 18px !important;
  }
}
</style>
